export default "<p>\r\n  second-collection works!\r\n</p>\r\n"